import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';
import {
    GET_DATA_ADMIN_DASHBOARD,
    getDataAdminDashboardSuccess,
    getDataAdminDashboardFailure
} from './action';
import { CORE_API } from '../../config';


export function* getDataAdminDashboardApiFunction(action) {
    
    let requestUrl = `${CORE_API}/admin/dashboard/overview/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(getDataAdminDashboardSuccess(createResult));
    } catch (err) {
        yield put(getDataAdminDashboardFailure(err))
    }
}
export function* getDataAdminDashboard() {
    yield takeLatest(GET_DATA_ADMIN_DASHBOARD, getDataAdminDashboardApiFunction);
}